import React, { useState } from "react";
import { Button, Form, Input } from "antd";
import GalleryImagePicker from "../blog/GalleryImagePicker";
import { CustomFieldProps } from "../../types/core";

interface ImageUrlPickerProps extends CustomFieldProps<any> {
  galleryId?: number;
  selectSize?: "thumbnail" | "hd" | "fhd" | "image" | "pdf_optimized";
}

const ImageUrlPicker = (props: ImageUrlPickerProps) => {
  const [pickerVisible, setPickerVisible] = useState(false);
  const form = Form.useFormInstance();

  const handleSelectImage = (imageUrl: string) => {
    form.setFieldsValue({ [props.formName]: imageUrl });
    setPickerVisible(false);
  };

  const imageUrl = Form.useWatch(props.formName, form);

  return (
    <>
      <Form.Item label={props.fieldSchema.label}>
        {imageUrl && <img src={imageUrl} alt="Cover" style={{ maxWidth: '200px', marginBottom: '10px', display: 'block' }} />}
        <Form.Item name={props.formName} noStyle>
            <Input
              readOnly
              placeholder="Click Select to choose an image"
              addonAfter={<Button onClick={() => setPickerVisible(true)}>Select</Button>}
            />
        </Form.Item>
      </Form.Item>
      <GalleryImagePicker
        visible={pickerVisible}
        onSelect={handleSelectImage}
        onCancel={() => setPickerVisible(false)}
        galleryId={props.galleryId}
        selectSize={props.selectSize}
      />
    </>
  );
};

export default ImageUrlPicker;
